import { render, staticRenderFns } from "./AppointmentItem.vue?vue&type=template&id=887098b8&"
import script from "./AppointmentItem.vue?vue&type=script&lang=js&"
export * from "./AppointmentItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports